<p> {{ version | json }} </p>
 
